import { yupResolver } from "@hookform/resolvers/yup";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { AgGridReact } from "ag-grid-react"; // AG Grid Component
import { LibraryAPI, LibraryByParentIdAPI } from "api";
import IconButton from "components/common/IconButton";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Button, Card, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";
import { CONSTANT_ROUTES } from "routes";
import { customSettings } from "utils/customConfig";
import * as yup from "yup";
import "./styles.css";
const schema = yup
  .object({
    type: yup.string().required("This field is required."),
    name: yup.string().required("This field is required."),
  })
  .required();

const options = [
  { value: "Infectious disease", label: "Infectious disease" },
  { value: "Chronic diseases", label: "Chronic diseases" },
  { value: "Genetic disorders", label: "Genetic disorders" },
  { value: "Autoimmune diseases", label: "Autoimmune diseases" },
  { value: "Mental health conditions", label: "Mental health conditions" },
  { value: "Neurological Disorders", label: "Neurological Disorders" },
  { value: "Gastrointestinal Disorders", label: "Gastrointestinal Disorders" },
  {
    value: "Renal and Urological Disorders",
    label: "Renal and Urological Disorders",
  },
  { value: "Musculoskeletal Disorders", label: "Musculoskeletal Disorders" },
];

export default function MedicalProblemsTable() {
  let isDarkBool = localStorage.getItem("isDark") === true;
  let isDarkTheme = localStorage.getItem("theme") === "dark";
  let auto = localStorage.getItem("theme") === "auto";
  const navigate = useNavigate();
  const [editingId, setEditingId] = useState(null);
  const [selectedTypeOption, setSelectedTypeOption] = useState(null);
  const { state } = useLocation();
  const location = useLocation();
  // const columnApiRef = useRef();
  const gridRef = useRef();
  const [colDefs, setColDefs] = useState([
    // { field: "", filter: false, headerName: "Select" },

    {
      field: "type",
      headerName: "Type",

      hide: false,
    },
    { field: "name", headerName: "Name", hide: false },
    // {
    //   field: "active",
    //   headerName: "Active",
    //   hide: false,
    //   cellStyle: {
    //     display: "flex",
    //     paddingRight: "30px",
    //     justifyContent: "center",
    //   },
    //   headerClass: "center-header",
    //   cellRenderer: (p) => <Checkbox checked={p?.data.active} />,
    // },
    // {
    //   headerName: "Action",
    //   field: "action",
    //   maxWidth: 120,
    //   filter: false,
    //   cellRenderer: (p) => (
    //     <CardDropdown>
    //       <div className="py-2">
    //         <Dropdown.Item
    //           // as={Link}
    //           onClick={() =>
    //             // navigate(`/libraries/categories/add-new-category/?id=${p.data.id}`)
    //             // () =>
    //             handleRowClick(p.data)
    //           }
    //           // href="/products/add-product"
    //           className="d-flex align-items-center gap-2 py-0"
    //         >
    //           <MdOutlineModeEdit />
    //           Edit
    //         </Dropdown.Item>
    //         {/* <Dropdown.Item
    //           onClick={() => handleDelete(p.data)}
    //           className="d-flex align-items-center gap-2 py-0"
    //         >
    //           <MdDeleteOutline />
    //           Delete
    //         </Dropdown.Item> */}
    //       </div>
    //     </CardDropdown>
    //   ),
    // },
    // {
    //   headerName: "Action",
    //   field: "action",
    //   maxWidth: 120,
    //   filter: false,
    //   headerComponent: () => (
    //     <div
    //       className="d-flex justify-content-center align-items-center w-100"
    //       style={{ height: "100%" }}
    //     >
    //       <IconButton
    //         icon="plus"
    //         size="sm"
    //         className="px-2 mb-0 pb-0"
    //         variant="falcon-default"
    //         onClick={() =>
    //           navigate(CONSTANT_ROUTES.ADD_NEW_MEDICAL_PROBLEM, {
    //             state: {
    //               patientId: location?.state?.id,
    //               patientName: location?.state?.name,
    //             },
    //           })
    //         }
    //       >
    //         <span className="ms-1">New</span>
    //       </IconButton>
    //     </div>
    //   ),
    //   // cellRenderer: (p) => (
    //   //   <div className="text-center">
    //   //     <MdDeleteOutline color="red" size={20} />
    //   //   </div>
    //   // ),
    // },
  ]);

  // const handleRowClick = (data) => {
  //   if (data) {
  //     data.patientName = location.state?.name;
  //     navigate(CONSTANT_ROUTES.ADD_NEW_MEDICAL_PROBLEM, { state: data });
  //   }
  // };

  const handleRowClick = (data) => {
    setEditingId(data.id);
    setValue("name", data.name);

    const foundOption = options.find((o) => o.value === data.type);
    const newOption = foundOption || { value: data.type, label: data.type };

    setSelectedTypeOption(newOption);
    setValue("type", newOption.value); // form value
    clearErrors("type");
  };

  const getData = async () => {
    const response = await LibraryByParentIdAPI.get({
      params: {
        library: 2,
        parentId: location?.state?.id ?? Number.MAX_SAFE_INTEGER,
      },
    });
    return response?.data?.data;
  };

  const handleDelete = async (info) => {
    console.log(info);
    try {
      await LibraryAPI.delete(info.id);
      toast.success("Record Deleted Successfully", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      const newData = await getData();
      gridApi.setGridOption("rowData", newData);
    } catch (error) {
      console.log(error);
      toast.error("Something went Wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
    }
  };

  const defaultColDef = {
    sortable: true,
    filter: false,
    // floatingFilter: true,
    flex: 1,
    // rowDrag: true,
  };

  //   ===============Custom Api Call start================

  let gridApi;
  let columnApi;

  const gridApiRef = useRef(null);
  const columnApiRef = useRef(null);

  const onGridReady = useCallback(
    async (e) => {
      // gridApi = e.api;
      // columnApi = e.columnApi;
      gridApiRef.current = e.api;
      columnApiRef.current = e.columnApi;
      // restoreState();
      const data = await getData();
      // console.log(data);
      e.api.applyTransaction({ add: data });
    },
    [window]
  );

  // ==========================Form==========================

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const {
    handleSubmit,
    reset,
    setValue,
    register,
    formState: { errors },
    clearErrors,
  } = methods;

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: editingId ?? 0, // Use 0 or omit if new
      library: 2,
      parentId1:
        location.state && !location.state.parentId1
          ? location.state.id
          : location.state?.parentId1,
      phone: "",
      email: "",
      logo: "",
      level: "",
      strength: "",
    };

    console.log(myData);

    try {
      if (!location.state) {
        toast.error("Please add Patient first", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
        return;
      }

      if (editingId) {
        await LibraryAPI.post(myData); // use PUT for update
        toast.success("Record updated successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      } else {
        await LibraryAPI.post(myData); // use POST for new
        toast.success("Record added successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      }

      // Clear form after submit
      reset({
        type: "",
        name: "",
      });
      setEditingId(null); // Clear edit mode
      setValue("type", "");
      setSelectedTypeOption(null);
      const newData = await getData();
      gridApiRef.current?.setGridOption("rowData", newData);
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
    }
  };

  // const {
  //   register,
  //   setValue,
  //   formState: { errors },
  //   clearErrors,
  // } = useFormContext();

  // const [typeValue, setTypeValue] = useState(state?.type);

  // useEffect(() => {
  //   setValue("type", typeValue);
  // }, [typeValue, setValue]);

  // const handleInputChange = (event) => {
  //   setTypeValue(event.target.value);
  // };

  // useEffect(() => {
  //   register("type", { required: true });
  // }, [register]);

  // useEffect(() => {
  //   if (state) {
  //     setValue("type", state.type);
  //   }
  // }, [state, setValue]);

  const handleSelectChange = (selectedOption) => {
    setSelectedTypeOption(selectedOption);
    setValue("type", selectedOption?.value || "");
    if (selectedOption) {
      clearErrors("type");
    }
  };

  const handleInputFocus = () => {
    clearErrors("type");
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: errors.type ? "red" : provided.borderColor,
      "&:hover": {
        borderColor: errors.type ? "red" : provided["&:hover"].borderColor,
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black", // Set the text color of the selected value to black
      padding: "7px",
    }),
    placeholder: (provided) => ({
      ...provided,
      padding: "7px",
    }),
    input: (provided) => ({
      ...provided,
      color: "black",
      paddingTop: "12px",
      paddingBottom: "12px",
      paddingLeft: "7px",
      paddingRight: "7px",
      // padding: "12px", // Set the input text color to black
    }),

    menu: (provided) => ({
      ...provided,
      color: "black",
      zIndex: 9999, // Adjust the zIndex as needed
    }),
  };

  // let initialSelectedOption = options.find(
  //   (option) => option.value === state?.type
  // );

  // if (initialSelectedOption == undefined) {
  //   initialSelectedOption =
  //     state && state.type
  //       ? { label: state?.type, value: state?.type }
  //       : undefined;
  // }

  return (
    <div>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="gx-2 gy-1 mb-2">
            <Col md="6">
              <Form.Group>
                {/* <CreatableSelect
                  options={options}
                  isClearable
                  placeholder={
                    <span>
                      Type{" "}
                      <span style={{ color: "red", fontSize: "12px" }}>*</span>
                    </span>
                  }
                  className={`${errors.type ? "is-invalid" : ""}`}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  onFocus={handleInputFocus}
                  onInputChange={handleInputFocus}
                  defaultValue={initialSelectedOption}
                /> */}
                <CreatableSelect
                  options={options}
                  isClearable
                  value={selectedTypeOption}
                  placeholder={
                    <span>
                      Type{" "}
                      <span style={{ color: "red", fontSize: "12px" }}>*</span>
                    </span>
                  }
                  className={`${errors.type ? "is-invalid" : ""}`}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  onFocus={handleInputFocus}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.type?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md="5">
              <Form.Group>
                <FloatingLabel
                  controlId="floatingInput"
                  label={
                    <span>
                      Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  className=""
                >
                  <Form.Control
                    type="text"
                    autoComplete="off"
                    placeholder="name@example.com"
                    isInvalid={!!errors.name}
                    {...register("name")}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name?.message}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Form.Group>
            </Col>
            <Col md={1} className="d-flex justify-content-start">
              <Button variant="primary" type="submit" style={{ width: "100%" }}>
                Ok
              </Button>
            </Col>
          </Row>
          {/* <Row className="gx-2 gy-3 my-1">
            <Col className="d-flex justify-content-end">
              <Button variant="primary" type="submit">
                Ok
              </Button>
            </Col>
          </Row> */}
        </Form>
      </FormProvider>

      <div
        className={`${
          isDarkBool || isDarkTheme || auto
            ? "ag-theme-quartz-dark"
            : "ag-theme-quartz"
        } rounded-0`} // applying the grid theme
        style={{ height: 500 }} // the grid will fill the size of the parent container
      >
        <Card className="h-100 shadow-none">
          {/* <Card.Header className="d-flex justify-content-between align-items-center  bg-body-tertiary mb-2">
            <h6 className="fs-10 mb-0 text-nowrap py-2 py-xl-0 ">
              Medical Problems
            </h6>
            <div className="d-flex gap-2">
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    New
                  </Tooltip>
                }
              >
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="plus"
                  transform="shrink-3"
                  onClick={() =>
                    navigate(CONSTANT_ROUTES.ADD_NEW_MEDICAL_PROBLEM, {
                      state: {
                        patientId: location?.state && location?.state.id,
                        patientName: location?.state?.name,
                      },
                    })
                  }
                >
                  <span className="d-none d-sm-inline-block ms-1">New</span>
                </IconButton>
              </OverlayTrigger>
              <TableHeaderDropdown>
                <div className="py-2">
                  <Dropdown.Item
                    onClick={saveState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Save State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={restoreState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Restore State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={resetState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Reset State
                  </Dropdown.Item>
                </div>
              </TableHeaderDropdown>
            </div>
          </Card.Header> */}

          <Card.Body className="p-0">
            {/* <button onClick={() => onExportClick()}>abc</button> */}

            <AgGridReact
              //   rowData={rowData}
              ref={columnApiRef}
              onGridReady={onGridReady}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              rowStyle={{ cursor: "pointer" }}
              // pagination={true}
              onRowDoubleClicked={(params) => handleRowClick(params.data)}
              overlayNoRowsTemplate="Nothing found - Looks empty over here"
            />
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

// const saveState = useCallback(() => {
//   const colState = columnApiRef.current.api.getColumnState();
//   setLocalStorage(colState);
//   console.log("column state saved");
// }, []);

// const restoreState = useCallback(() => {
//   const colState = getLocalStorage();
//   if (!colState) {
//     console.log("no columns state to restore by, you must save state first");
//     return;
//   }
//   columnApiRef.current.api.applyColumnState({
//     state: colState,
//     applyOrder: true,
//   });
//   console.log("column state restored");
// }, []);

// const resetState = useCallback(() => {
//   columnApiRef.current.api.resetColumnState();
//   clearLocalStorage();
//   console.log("column state reset");
// }, []);

// const onFilterTextBoxChanged = useCallback(() => {
//   columnApiRef.current.api.setGridOption(
//     "quickFilterText",
//     document.getElementById("filter-text-box").value
//   );
// }, []);
